<template>
  <div>
    <AppPaginaBarraSuperior :items="items" :menu-lateral="true">
    </AppPaginaBarraSuperior>
    <AppPaginaTitulo
      titulo="Dispositivos do Servidor"
      descricao="Edite os dispositivos do servidor"
    />
    <div class="card m-3 shadow-sm">
      <div class="card-body">
        <DispositivoTable />
      </div>
    </div>
  </div>
</template>
<script>
import AppPaginaBarraSuperior from "../components/layout/AppPaginaBarraSuperior.vue";
import AppPaginaTitulo from "../components/layout/AppPaginaTitulo.vue";

import DispositivoTable from "../components/servidor/DispositivoTable.vue";

export default {
  components: {
    AppPaginaBarraSuperior,
    AppPaginaTitulo,
    DispositivoTable
  },
  data() {
    return {
      items: [
        {
          text: "Dispositivos",
          active: true
        }
      ]
    };
  }
};
</script>

<style lang="sass"></style>
